export default "__VITE_ASSET__706e7e9e__"